import { useMutation } from "@tanstack/react-query";
import Swal from "sweetalert2";
import { api } from "../../libs/axios";
import { AxiosErrorResponse } from "../pdv/mutationReserva";
import { queryClient } from "../../libs/queryClient";
import { formatBRL } from "../../utils/currency";

type CancelarBilhetePayload =
  | string
  | number
  | {
      id: string | number;
      multa?: number;
      multaNaFatura?: boolean;
    };

export function useMutationCancelarBilhete() {
  return useMutation({
     mutationFn: async (payload: CancelarBilhetePayload) => {
      const id = typeof payload === "string" || typeof payload === "number"
        ? payload
        : payload.id;
      const response = await api.delete(`/pedido/cancelar/bilhete/${id}`);

      return response.data;
    },
    onSuccess: async (_, payload) => {
      const hasMultaPayload = typeof payload === "object";
      const multa = hasMultaPayload ? Number(payload.multa ?? 0) : 0;
      const multaNaFatura = hasMultaPayload ? Boolean(payload.multaNaFatura) : false;

      queryClient.invalidateQueries({ queryKey: ["faturas"], exact: false });
      queryClient.invalidateQueries({ queryKey: ["fatura"], exact: false });

      Swal.fire({
        title: 'Bilhete Devolvido',
        icon: 'success',
        html: multa > 0 && multaNaFatura
          ? `A taxa de ${formatBRL(multa)} foi lançada na sua fatura.`
          : undefined,
      });
    },
    onError: (err: AxiosErrorResponse) => {      
      const requestId = err.response?.headers?.['request-id'];

      Swal.fire({
        title: "Erro ao cancelar bilhete",
        icon: "error",
        text: `${err.response?.data?.data?.message || "Erro desconhecido"} ${requestId ? `- Request ID: ${requestId}` : ''}`,
      })
    }
  });
}
